import React, { useState, useEffect } from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
// core components
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import Button from '@material-ui/core/Button';
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Parallax from "components/Parallax/Parallax.js";
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import spaghetti from "assets/img/spaghetti.jpg";
import { Helmet } from 'react-helmet'

//import Ads5 from "../../Main/Sections/Ads5.js";
import Config from "../../../config.js"
import Axios from "axios";
import swal from 'sweetalert'

import styles from "assets/jss/material-kit-react/views/spaghetti.js";
import { FormControl, InputLabel, Select, MenuItem, TextField } from "@material-ui/core";
import moment from "moment";

const useStyles = makeStyles(styles);

export default function AdminPage(props) {
    const classes = useStyles();
    const [team, setTeam] = React.useState(null);
    const { ...rest } = props;
    const imageClasses = classNames(
        classes.imgRaised,
        classes.imgRoundedCircle,
        classes.imgFluid
    );
    const [selectedTeam, setSelectedTeam] = React.useState(null);
    const [code, setCode] = React.useState(null);
    const [freeze, setFreeze] = React.useState(false);
    const [result, setResult] = React.useState(null);
    const [hour, setHour] = React.useState(10);
    const [minutes, setMinutes] = React.useState();
    useEffect(() => {
        getData()
        setMinutes(moment().minute())
        setHour(moment().hour())
    }, []);
    const handleDropDownChange = function (event) {
        setSelectedTeam(event.target.value);
    }
    const handleFreezeDropDownChange = function (event) {
        setFreeze(event.target.value == "true" ? true : false);
    }
    const call = function () {
        Axios.post(Config.api + "SCChallenge/Answer",
            {
                code: code,
                team: selectedTeam,
                text: result,
                challenge: "1",
                freeze: freeze,
                hour:hour,
                minutes:minutes
            },
            {
                headers: {
                    apikey: Config.apikey,
                    Authorization: "Bearer " + localStorage.getItem('token')

                }
            }).then(async (result) => {
                swal("با موفقیت انجام شد.");
            }).catch((err) => {
                if (err && err.response && err.response.status && err.response.status === 401) {
                    localStorage.removeItem('token');
                    props.history.push("/SignIn");
                }
                else if (err && err.response && err.response.status && err.response.status === 422)
                    swal("اطلاعات ارسالی نادرست است.");
                else if (err && err.response && err.response.data && err.response.data.message && err.response.data.message.pr) {
                    swal(err.response.data.message.pr);
                }
                else swal("خطایی رخ داده است.")
            })

    }
    const getData = () => {
        Axios.post(Config.api + "SCChallenge/Teams", {
            id: "1",
        },
            {
                headers: {
                    apikey: Config.apikey,
                    Authorization: "Bearer " + localStorage.getItem('token')

                }
            }).then(async (result) => {
                setTeam(result.data.data)
            }).catch((err) => {
                if (err && err.response && err.response.status && err.response.status === 401) {
                    localStorage.removeItem('token');
                    props.history.push("/SignIn");
                }
                /*else if (err && err.response && err.response.status && err.response.status === 422)
                    swal("اطلاعات ارسالی نادرست است.");
                else if (err && err.response && err.response.data && err.response.data.message && err.response.data.message.pr) {
                    swal(err.response.data.message.pr);
                }
                else swal("خطایی رخ داده است.")*/
            })
    }

    return (
        <div>
            <Header
                color="transparent"
                brand="Material Kit React"
                rightLinks={<HeaderLinks />}
                fixed
                changeColorOnScroll={{
                    height: 200,
                    color: "white"
                }}
                {...rest}
            />
            <Parallax small filter image={require("assets/img/bg5.jpg")} />
            <div className={classNames(classes.main, classes.mainRaised)}>
                <div>
                    <div className={classes.container}>
                        <GridContainer justify="center" className={classes.box}>
                            <GridItem xs={12} sm={12} md={12}>
                                <div className={classes.topdev}>
                                    <div>
                                        <img src={spaghetti} alt="..." className={imageClasses} />
                                    </div>
                                    <div className={classes.name}>
                                        <h3 className={classes.title}>ادمین مسابقات کد نویسی مبهم</h3>
                                        <div align="right">
                                            <div className={classes.formInput}>
                                                <FormControl style={{ width: "100px" }} className={classes.formControl}>
                                                    <InputLabel htmlFor="team">نوع ثبت</InputLabel>
                                                    <Select
                                                        defaultValue={false}
                                                        onChange={handleFreezeDropDownChange}
                                                    >
                                                        <MenuItem value="false">
                                                            <em>عادی</em>
                                                        </MenuItem>
                                                        <MenuItem value="true">
                                                            <em>فریز</em>
                                                        </MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </div>
                                            <br />
                                            <div className={classes.formInput}>
                                                <FormControl style={{ width: "200px" }} className={classes.formControl}>
                                                    <InputLabel htmlFor="team">تیم</InputLabel>
                                                    <Select
                                                        onChange={handleDropDownChange}
                                                    >
                                                        <MenuItem value="">
                                                            <em>انتخاب کنید</em>
                                                        </MenuItem>
                                                        {team && team.map((item, index) => {
                                                            return (<MenuItem value={item.teamName}>{item.teamName}</MenuItem>)
                                                        })}
                                                    </Select>
                                                </FormControl>
                                            </div>
                                            <br />
                                            <div className={classes.formInput}>
                                                <FormControl className={classes.formControl}>
                                                    <InputLabel htmlFor="code"></InputLabel>
                                                    <TextField name="code" id="standard-basic" onChange={(event) => setCode(event.target.value)} label="کد سوال" helperText="5454" />
                                                </FormControl>
                                                <FormControl  style={{marginRight:"10px"}} className={classes.formControl}>
                                                    <InputLabel htmlFor="result"></InputLabel>
                                                    <TextField name="result" id="standard-basic" onChange={(event) => setResult(event.target.value)} label="نتیجه کد" helperText="1234" />
                                                </FormControl>
                                            </div>
                                            <br />
                                            <div className={classes.formInput}>
                                                <FormControl className={classes.formControl}>
                                                    <InputLabel htmlFor="hour"></InputLabel>
                                                    <TextField value={hour} name="hour" id="standard-basic" onChange={(event) => setHour(event.target.value)} label="ساعت" helperText="10" />
                                                </FormControl>
                                                <FormControl style={{marginRight:"10px"}}  className={classes.formControl}>
                                                    <InputLabel htmlFor="minutes"></InputLabel>
                                                    <TextField  value={minutes} name="minutes" id="standard-basic" onChange={(event) => setMinutes(event.target.value)} label="دقیقه" helperText="50" />
                                                </FormControl>
                                            </div>
                                            <br />
                                            <div className={classes.formInput}>
                                                <Button variant="contained" color="primary" disableElevation onClick={call}>
                                                    ثبت امتیاز
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </GridItem>
                        </GridContainer>

                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}
